import styled from 'styled-components';
import {typography} from '@atlaskit/theme';

const PageTitle = styled.div`
  ${typography.h700()};
  margin-top: 20px;
`;

export default PageTitle;
